import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'lib/jquery'
import App from 'frontend/app'
import memoizeOne from 'memoize-one'
import classNames from 'classnames'
import Select from 'react-select'
import ActionModal from 'frontend/components/action-modal'
import CommonIcons from 'frontend/components/common-icons'
import csrf from '../../../lib/csrf'
import Current from 'frontend/lib/current'

export default class EventBookingForm extends Component {
  static propTypes = {
    pageController: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
    submitDisabled: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)
    props.pageController.formComponent = this
    this.state = this.initialState = {
      name: '',
      email: '',
      phone: '',
      message: '',
      personsCount: 2,
      minPersons: 2,
      errors: {},
      location: null,
      submitDisabled: props.submitDisabled,
      working: false
    }
    this.incrementPersonsCount = this.incrementPersonsCount.bind(this)
    this.decrementPersonsCount = this.decrementPersonsCount.bind(this)
    this.submit = this.submit.bind(this)
    this.inputRefs = {}
    this.errorRefs = {}
  }

  onReCaptchaSuccess (recaptchaData = {}) {
    this.recaptchaData = recaptchaData
    this.setState({ submitDisabled: false })
  }

  reset () {
    this.setState(this.initialState)
  }

  componentDidMount () {
    this.fetchLocations()
  }

  fetchLocations () {
    $.ajax({
      url: '/' + Current.cityId + '/locations.json',
      success: (locations) => this.setState({ locations }),
      error: (response) => {
        App.report('EventBookingForm#fetchLocations', 'Error while fetching locations', response)
        this.setState({ errorMessage: 'Error while fetching locations' })
      }
    })
  }

  get locationsAsOptions () {
    if (this.state.locations) {
      return this.constructor.memoizedBuildLocationsOptions(this.state.locations)
    } else {
      return []
    }
  }

  incrementPersonsCount () {
    const { personsCount } = this.state

    this.setState({ personsCount: personsCount + 1 })
  }

  decrementPersonsCount () {
    const { minPersons, personsCount } = this.state

    if (personsCount <= minPersons) return

    this.setState({ personsCount: personsCount - 1 })
  }

  validate (success) {
    this.setState({ errors: {} }, () => {
      const { errors, email } = this.state;
      ['name', 'email', 'phone', 'message'].forEach((name) => {
        if (this.state[name].trim().length == 0) {
          errors[name] = "can't be blank"
        }
      })

      if (!errors.email && errors.phone) {
        delete errors.phone
      }

      if (!errors.email && email.match(/\w@\w/) === null) {
        console.log('email', email)
        errors.email = `Please include an '@' in the email address. '${email}' is missing an '@'.`
      }

      this.setState({ errors }, () => {
        if (Object.keys(errors).length === 0) {
          success()
        } else {
          this.displayErrors()
          this.scrollToFirstError()
        }
      })
    })
  }

  submit () {
    this.validate(() => {
      const body =
        `Phone:\n${this.state.phone.trim()}\n\n` +
        'Preferred location:\n' +
        `${(this.state.location && this.state.location.name.trim()) || 'No'}\n\n` +
        `Persons count:\n${this.state.personsCount}\n\n` +
        `Message:\n${this.state.message.trim()}\n\n`

      const message = {
        subject_name: 'events',
        name: this.state.name.trim(),
        email: this.state.email,
        text: body
      }

      this.setState({ working: true })

      $.ajax({
        url: '/messages.json',
        method: 'post',
        data: JSON.stringify({ message, ...this.recaptchaData, ...csrf.data }),
        success: () => {
          this.reset()
          this.setState({ showConfirmation: true })
        },
        error: (response) => {
          this.setState({ working: false })
          const data = response.responseJSON
          if (data && data.errors) {
            this.setState({ errors: data.errors }, () => {
              this.displayErrors()
              this.scrollToFirstError()
            })
          } else {
            App.report('EventBookingForm#submit', 'Error submitting request', response)
            this.setState({ errorMessage: 'Something went wrong...' })
          }
        }
      })
    })
  }

  scrollToFirstError () {
    const name = Object.keys(this.state.errors)[0]
    if (!name) return

    const el = this.errorRefs[name]
    if (!el) return

    const elRect = el.getBoundingClientRect()
    const top = elRect.top + window.pageYOffset
    const middle = top - window.innerHeight / 2
    window.scrollTo({ top: middle, left: 0, behavior: 'smooth' })
  }

  displayErrors () {
    Object.keys(this.state.errors)
      .reverse()
      .forEach((name) => {
        const el = this.inputRefs[name]

        if (!el) return

        el.setCustomValidity(this.state.errors[name])
        el.reportValidity()
      })
  }

  setField (name, value) {
    const { errors } = this.state
    delete errors[name]
    this.setState({ [name]: value, ...{ errors } })
  }

  renderFieldError (name) {
    if (this.state.errors[name]) {
      return (
        <div
          className="error"
          ref={(ref) => {
            this.errorRefs[name] = ref
          }}
        >
          {this.state.errors[name]}
        </div>
      )
    }
    return null
  }

  renderErrorMessage () {
    if (this.state.errorMessage) {
      return (
        <ActionModal
          title="Error"
          body={this.state.errorMessage}
          onClose={() => {
            this.setState({ errorMessage: null })
          }}
          className="confirmation_modal" // TODO: remove or change to error_modal class
        />
      )
    }

    return null
  }

  renderConfirmation () {
    if (this.state.showConfirmation) {
      return (
        <ActionModal
          title=""
          body={
            <div>
              <div className="icon_place">
                <CommonIcons item="common-check-circle-r" className="icon" width={40} height={40} />
              </div>
              <p>Thanks! Event coordinator will contact you shortly.</p>
            </div>
          }
          className="confirmation_modal"
          rightButtonLabel="Close"
          onRightClick={() => {
            this.setState({ showConfirmation: false })
          }}
          onClose={() => {
            this.setState({ showConfirmation: false })
          }}
          showCloseButton={false}
        />
      )
    }

    return null
  }

  render () {
    return (
      <div className="reservation_form">
        {this.renderErrorMessage()}
        {this.renderConfirmation()}
        <div className="fieldset">
          <div className={classNames('field', { error: this.state.errors.name })}>
            <div className="input_wrap name">
              <input
                type="text"
                placeholder="Your Name"
                className="input_field"
                id="booking-form-name"
                value={this.state.name}
                onChange={(e) => this.setField('name', e.target.value)}
                ref={(ref) => { this.errorRefs.name = this.inputRefs.name = ref }}
              />
              <label htmlFor="booking-form-name" className="input_label">
                Your Name
              </label>
            </div>
          </div>
          <div className={classNames('field', { error: this.state.errors.email })}>
            <div className="input_wrap email">
              <input
                type="email"
                placeholder="Email"
                className="input_field"
                id="booking-form-email"
                value={this.state.email}
                onChange={(e) => this.setField('email', e.target.value.trim())}
                ref={(ref) => { this.errorRefs.email = this.inputRefs.email = ref }}
              />
              <label htmlFor="booking-form-email" className="input_label">
                Email
              </label>
            </div>
          </div>
        </div>
        <div className="fieldset">
          <div className={classNames('field', { error: this.state.errors.phone })}>
            <div className="input_wrap phone">
              <input
                type="tel"
                placeholder="Phone"
                className="input_field"
                id="booking-form-phone"
                value={this.state.phone}
                onChange={(e) => this.setField('phone', e.target.value)}
                ref={(ref) => { this.errorRefs.phone = this.inputRefs.phone = ref }}
              />
              <label htmlFor="booking-form-phone" className="input_label">
                Phone
              </label>
            </div>
          </div>
          <div className={classNames('field location_field', { error: this.state.errors.location })}>
            <Select
              searchable={false}
              clearable={false}
              id="booking-form-location"
              className="location"
              placeholder={
                (this.state.location && this.state.location.name) || 'Preferred location'
              }
              options={this.locationsAsOptions}
              onChange={(option) => this.setField('location', option.value)}
            />
            {this.renderFieldError('location')}
          </div>
        </div>
        <div className="fieldset">
          <div className={classNames('field', { error: this.state.errors.personsCount })}>
            <div className="select_persons_count">
              <label>Number of persons</label>
              <div className="persons_count_input">
                <button className="minus" onClick={this.decrementPersonsCount}>-</button>
                <input
                  type="number"
                  min={this.state.minPersons}
                  value={this.state.personsCount}
                  onChange={(e) => this.setField('personsCount', e.target.value)}
                  ref={(ref) => { this.errorRefs.personsCount = this.inputRefs.personsCount = ref }}
                />
                <button className="plus" onClick={this.incrementPersonsCount}>+</button>
              </div>
            </div>
          </div>
          <div className={classNames('field', { error: this.state.errors.message })}>
            <div className="input_wrap message">
              <textarea
                type="text"
                placeholder="Message"
                id="booking-form-message"
                className="input_field"
                value={this.state.message}
                onChange={(e) => this.setField('message', e.target.value)}
                ref={(ref) => { this.errorRefs.message = this.inputRefs.message = ref }}
              />
              <label htmlFor="booking-form-message" className="input_label">
                Message
              </label>
            </div>
          </div>
        </div>
        <div className="button_place">
          <button
            className="button"
            onClick={this.submit}
            disabled={this.state.working || this.state.submitDisabled}
          >
            {this.state.working ? 'Processing...' : 'Reserve a Party Room'}
          </button>
        </div>
      </div>
    )
  }

  static buildLocationSelectOptionLabel (location) {
    return (
      <div className="location_option">
        <div className="name">{location.name}</div>
        <div className="address">{location.address.local}</div>
      </div>
    )
  }

  static buildLocationsOptions (locations) {
    return locations.map((location) => {
      return {
        label: this.buildLocationSelectOptionLabel(location),
        value: location
      }
    })
  }
}

EventBookingForm.memoizedBuildLocationsOptions = memoizeOne(
  EventBookingForm.buildLocationsOptions
)
